import { request } from '@/define'

import { IResponseData } from '../request'

export class CommonApis {
    /** 短链获取游戏id、渠道id */
    gameChannelInfo(params: { sign: string }) {
        return request.post('/web/game/game-channel-info', params)
    }

    /** 获取游戏详情 */
    getGameDetail(params: {}) {
        return request.post('/web/game/getGameDetail', params)
    }

    /** 获取游戏安装引导 */
    getGameInstallGuide(params: { gameId: string; channelId: string }): Promise<IResponseData> {
        return request.post('/web/game/getGameInstallGuide', params)
    }

    /** 获取页面配置信息 */
    getLandingPageConfigByGameId(params: { gameId: string }): Promise<IResponseData> {
        return request.post('/web/game/getLandingPageConfigByGameId', params)
    }

    /** 渠道ID */
    checkChannelId(params: { gameId: string; channelId: string }): Promise<IResponseData> {
        return request.post('/web/game/checkChannelId', params)
    }
}
